import React, { createContext, useContext, useState, useCallback } from "react";

const UserContext = createContext();

/**
 * UserProvider — contexto global con los datos del usuario autenticado.
 * Permite que cualquier pantalla acceda a userid, userName, userType y userEmail
 * sin necesidad de prop drilling.
 */
export const UserProvider = ({ children }) => {
  const [userData, setUserDataState] = useState({
    userid: "",
    userName: "",
    userType: null,
    userEmail: "",
  });

  // Actualiza todos los campos de usuario de una sola vez
  const setUserData = useCallback((data) => {
    setUserDataState((prev) => ({ ...prev, ...data }));
  }, []);

  return (
    <UserContext.Provider
      value={{
        userid: userData.userid,
        userName: userData.userName,
        userType: userData.userType,
        userEmail: userData.userEmail,
        // Multi-rol: roles disponibles para el email y función para cambiar de plataforma.
        availableRoles: userData.availableRoles || [],
        switchRole: userData.switchRole || null,
        setUserData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

/**
 * Hook para consumir el contexto de usuario.
 * Retorna { userid, userName, userType, userEmail, setUserData }.
 */
export const useUser = () => {
  const ctx = useContext(UserContext);
  if (!ctx) {
    throw new Error("useUser debe usarse dentro de un <UserProvider>");
  }
  return ctx;
};
